define([
	'internal_util/Util',
	'internal_util/UiUtil',
	'amdi18n-loader?!identity/nls/IdentityButtonView_strings',
        'amdi18n-loader?!state/nls/PrivacyPolicyState_strings',
        'amdi18n-loader?!state/nls/IdentityCreationState_strings',
	'lib/jquery'
], function (
	Util,
	UiUtil,
	Strings,
        PrivacyStrings,
        CreationStrings,
	jQuery
) {
	'use strict';

	/**
	 * NoIdentityButtonView class
	 */
	return function (create, importID, scanqrcode, revoke) {
		var _view;

		_view = (function () {
			var $view = jQuery(
					'<div id="skIdS_identity-button-container">' +
						'<button id="skIdS_show-buttons-button" type="button" class="btn btn-default"></button>' +
						'<div>' +
							'<button id="skIdS_create-button" type="button" class="btn btn-default skIdS_identity-button"></button>' +
//							'<button id="skIdS_import-button" type="button" class="btn btn-default skIdS_identity-button"></button>' +
//							'<button id="skIdS_importQR-button" type="button" class="btn btn-default skIdS_identity-button"></button>' +
							'<button id="skIdS_revoke-button" type="button" class="btn btn-default skIdS_identity-button"></button>' +
						'</div>' +
					'</div>');

			$view.find('.skIdS_identity-button').on('click', function () {
				$view.find('.skIdS_identity-button').removeClass('skIdS_identity-button-active');
				jQuery(this).addClass('skIdS_identity-button-active');
			});

			$view.find('#skIdS_show-buttons-button')
				.text(Strings.show_buttons)
				.on('click', function () {
					toggleButtons();
				});

			$view.find('#skIdS_create-button')
				.text(PrivacyStrings.create_cloud_identity)
				.on('click', function () {
					toggleButtons();
					Util.callCallbacks(create);
				});

//			$view.find('#skIdS_import-button')
//				.text(CreationStrings.import)
//				.on('click', function () {
//					toggleButtons();
//					Util.callCallbacks(importID);
//				});

//			$view.find('#skIdS_importQR-button')
//				.text(Strings.transfer)
//				.on('click', function () {
//					toggleButtons();
//					Util.callCallbacks(scanqrcode);
//				});

			$view.find('#skIdS_revoke-button')
				.text(PrivacyStrings.revoke_cloud_identities)
				.on('click', function () {
					toggleButtons();
					Util.callCallbacks(revoke);
				});

			return $view;
		})();


		// private methods

		function toggleButtons() {
			if (_view.find('#skIdS_show-buttons-button').is(':visible')) {
				UiUtil.scrollTo(_view);

				_view.children().last().toggleClass('skIdS_shown');
			}
		}


		// public methods

		this.get = function () {
			return _view;
		};

		this.removeActiveStates = function () {
			_view.find('button').removeClass('skIdS_identity-button-active');
		};

		this.hideButtonMenu =  function () {
			if (_view.find('#skIdS_show-buttons-button').is(':visible')
					&& _view.children().last().hasClass('skIdS_shown')) {
				_view.children().last().removeClass('skIdS_shown');
			}
		};

		this.update = function (identity, canCreate) {
			
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/identity/NoIdentityButtonView.js
// module id = 332
// module chunks = 1